// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* ACTUALLY, THIS IS EDITED ;)
THIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST
GRID UNITS.

ALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM \`layout-contents.js\`*/

/* layout contants from \`layout-constants.js\`, minus 1px */

.tool-select-base_mod-tool-select_FczHR {
  display: inline-block;
  margin: 0.25rem;
  border: none;
  border-radius: 0.25rem;
  outline: none;
  background: none;
  padding: 0.25rem;
  font-size: 0.85rem;
  -webkit-transition: 0.2s;
  transition: 0.2s;
}

.tool-select-base_mod-tool-select_FczHR.tool-select-base_is-selected_IwVA9 {
  background-color: var(--paint-looks-secondary, #855cd6);
}

.tool-select-base_mod-tool-select_FczHR:focus {
  outline: none;
}

img.tool-select-base_tool-select-icon_eWcCc {
  width: 2rem;
  height: 2rem;
  -webkit-box-flex: 1;
  -webkit-flex-grow: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  vertical-align: middle;
  -webkit-filter: var(--paint-filter-icon-gray, none);
          filter: var(--paint-filter-icon-gray, none);
}

.tool-select-base_mod-tool-select_FczHR.tool-select-base_is-selected_IwVA9 .tool-select-base_tool-select-icon_eWcCc {
  /* Make the tool icons white while selected by making them black and inverting */
  -webkit-filter: brightness(0) invert(1);
          filter: brightness(0) invert(1);
}

@media only screen and (max-width: 1256px) {
  .tool-select-base_mod-tool-select_FczHR {
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/tool-select-base/tool-select-base.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;;oDAEoD;;AAEpD;;;;kFAIkF;;AAElF,0DAA0D;;AAE1D;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;MAChB,oBAAoB;UAChB,YAAY;EACpB,sBAAsB;EACtB,mDAAmD;UAC3C,2CAA2C;AACrD;;AAEA;EACE,gFAAgF;EAChF,uCAAuC;UAC/B,+BAA+B;AACzC;;AAEA;EACE;IACE,SAAS;EACX;AACF","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* ACTUALLY, THIS IS EDITED ;)\nTHIS WAS CHANGED ON 10/25/2017 BY @mewtaylor TO ADD A VARIABLE FOR THE SMALLEST\nGRID UNITS.\n\nALSO EDITED ON 11/13/2017 TO ADD IN CONTANTS FOR LAYOUT FROM `layout-contents.js`*/\n\n/* layout contants from `layout-constants.js`, minus 1px */\n\n.mod-tool-select {\n  display: inline-block;\n  margin: 0.25rem;\n  border: none;\n  border-radius: 0.25rem;\n  outline: none;\n  background: none;\n  padding: 0.25rem;\n  font-size: 0.85rem;\n  -webkit-transition: 0.2s;\n  transition: 0.2s;\n}\n\n.mod-tool-select.is-selected {\n  background-color: var(--paint-looks-secondary, #855cd6);\n}\n\n.mod-tool-select:focus {\n  outline: none;\n}\n\nimg.tool-select-icon {\n  width: 2rem;\n  height: 2rem;\n  -webkit-box-flex: 1;\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  vertical-align: middle;\n  -webkit-filter: var(--paint-filter-icon-gray, none);\n          filter: var(--paint-filter-icon-gray, none);\n}\n\n.mod-tool-select.is-selected .tool-select-icon {\n  /* Make the tool icons white while selected by making them black and inverting */\n  -webkit-filter: brightness(0) invert(1);\n          filter: brightness(0) invert(1);\n}\n\n@media only screen and (max-width: 1256px) {\n  .mod-tool-select {\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mod-tool-select": `tool-select-base_mod-tool-select_FczHR`,
	"modToolSelect": `tool-select-base_mod-tool-select_FczHR`,
	"is-selected": `tool-select-base_is-selected_IwVA9`,
	"isSelected": `tool-select-base_is-selected_IwVA9`,
	"tool-select-icon": `tool-select-base_tool-select-icon_eWcCc`,
	"toolSelectIcon": `tool-select-base_tool-select-icon_eWcCc`
};
export default ___CSS_LOADER_EXPORT___;
